export default __webpack_public_path__ + "static/media/logo.75e964a8.png";